import { Box, Divider, Grid, Typography } from '@mui/material'
import { useScreenSize } from '../../../hooks/useScreenSize'
import { useStoreState } from '../../../store/hooks'
import { secondaryFont } from '../../../theme/theme-v2'
import { AchievementCard } from '../components/rewards/AchievementCard'
import { ClaimedReward } from '../components/rewards/ClaimedReward'
import { Loader } from '../components/rewards/Loader'
import { WeeklyCountdown } from '../components/rewards/WeeklyCountdown'

export const RewardsAchievements = () => {
    const { isMobile } = useScreenSize()
    const rewards = useStoreState((state) => state.rewardsService.rewards)

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={2}
            width="100%"
            sx={{
                '>:first-child': {
                    mb: -1,
                },
            }}
        >
            <WeeklyCountdown />
            {!rewards && <Loader />}
            {rewards?.map((reward) => (
                <Box key={reward.category.id}>
                    <Typography
                        variant={isMobile ? 'h6' : 'h5'}
                        fontFamily={secondaryFont}
                        textTransform="uppercase"
                        fontWeight="bold"
                    >
                        {reward.category.name}
                    </Typography>
                    <Divider sx={{ mb: 1.5, mt: 0.5, backgroundColor: 'common.white', height: '2px' }} />

                    <Grid container spacing={1.5}>
                        {reward.achievements?.map((achievement) => (
                            <AchievementCard key={achievement.challengeId} achievement={achievement} />
                        )) || (
                            <Grid item>
                                <ClaimedReward />
                            </Grid>
                        )}
                    </Grid>
                </Box>
            ))}
        </Box>
    )
}
